import { render, staticRenderFns } from "./TransaksiGadai.vue?vue&type=template&id=5aa81b9c&scoped=true&"
import script from "./TransaksiGadai.vue?vue&type=script&lang=js&"
export * from "./TransaksiGadai.vue?vue&type=script&lang=js&"
import style0 from "./TransaksiGadai.vue?vue&type=style&index=0&id=5aa81b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa81b9c",
  null
  
)

export default component.exports